export const normalizeId = (id) => {
    if (id === null || id === undefined || id === "") return undefined;
    const n = Number(id);
    return Number.isNaN(n) ? id : n;
};

export const sameId = (a, b) => normalizeId(a) === normalizeId(b);

export const blockOptionLabel = (block) =>
    `${block?.block_name || ""}${block?.branch_name ? ` (${block.branch_name})` : ""}`.trim();

export const floorOptionLabel = (floor) => floor?.floor_name || "";

export const ensureBlockOption = (list, blockId, blockName, branchName = "") => {
    if (!blockId) return list || [];
    const arr = [...(list || [])];
    if (arr.some((b) => sameId(b.id, blockId))) return arr;
    return [
        ...arr,
        {
            id: normalizeId(blockId),
            block_name: blockName || `Block #${blockId}`,
            branch_name: branchName || "",
        },
    ];
};

export const ensureFloorOption = (list, floorId, floorName) => {
    if (!floorId) return list || [];
    const arr = [...(list || [])];
    if (arr.some((f) => sameId(f.id, floorId))) return arr;
    return [
        ...arr,
        {
            id: normalizeId(floorId),
            floor_name: floorName || `Floor #${floorId}`,
        },
    ];
};

export const BLOCK_NAME_MAX = 50;
export const FLOOR_NAME_MAX = 50;
